import { Text } from '@teamsparta/stack-text';
import { vars } from '@teamsparta/stack-tokens';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function PostDetailCategory({ children }: Props) {
  return (
    <Text
      as='span'
      font={{ mobile: 'tag2', desktop: 'tag2' }}
      color={vars.neutral[50]}
      style={{
        padding: '2px 4px',
        borderRadius: '4px',
        backgroundColor: '#9DA7AE33',
      }}
    >
      {children}
    </Text>
  );
}
